import { Role, useGetAppSelectorInfo, useGetUserInfo } from 'auth';
import classNames from 'classnames';
import { Link, Outlet, useSearchParams } from 'react-router-dom';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { useCurrentUserQuery } from '@/modules/auth/queries/user.tsx';
import { useSidebarProfileMenuOptions } from '@/modules/common/hooks/useSidebarProfileMenuOptions.ts';
import { useAdminSidebarOptions } from '@/modules/admin-dashboard/hooks/useAdminSidebarOptions.ts';
import { adminDashboardPaths } from '@/modules/admin-dashboard/routes.tsx';
import { Sidebar, TopBar } from 'ui';
import { LogoSrWhite } from 'ui/icons/logo';

const AdminSrDashboardWrapper = () => {
  const { avatar } = useGetUserInfo();
  const { data: currentUser } = useCurrentUserQuery();
  const [params] = useSearchParams();

  const appSelectorInfo = useGetAppSelectorInfo();
  const menuOptions = useAdminSidebarOptions();
  const profileOptions = useSidebarProfileMenuOptions();
  return (
    <div
      className={classNames(
        'bg-gray-900 sm:h-screen w-full flex sm:flex-row flex-col h-[calc(100%-56px)]',
      )}
    >
      <TopBar
        label={
          <Link to={{ pathname: adminDashboardPaths.static.registers, search: params.toString() }}>
            <img src={LogoSrWhite} alt="logo" className="h-8" />
          </Link>
        }
        menuItems={menuOptions}
        profileMenuItems={profileOptions}
        user={currentUser}
        avatarUrl={avatar}
        entity={{ type: 'Admin' }}
        appSelectorInfo={appSelectorInfo}
      />
      <Sidebar
        label={
          <Link to={{ pathname: adminDashboardPaths.static.registers, search: params.toString() }}>
            <img src={LogoSrWhite} alt="logo" className="h-8" />
          </Link>
        }
        avatarUrl={avatar}
        menuItems={menuOptions}
        profileMenuItems={profileOptions}
        user={currentUser}
        entity={{ type: 'Admin' }}
        appSelectorInfo={appSelectorInfo}
      />
      <main
        className={classNames(
          'overflow-auto flex flex-col w-full sm:h-full h-[calc(100%-56px)] sm:flex-grow-0 flex-grow relative top-0 bottom-0',
          'bg-white items-start justify-center rounded-tl-xl rounded-tr-xl sm:rounded-tr-none sm:rounded-bl-xl rounded-bl-none',
        )}
      >
        <Outlet />
      </main>
    </div>
  );
};

export default withPrivateAccess(AdminSrDashboardWrapper, Role.SR_ADMIN);
